"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var React = require("react");
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row(props) {
        return _super.call(this, props) || this;
    }
    Row.prototype.render = function () {
        return (React.createElement("div", { className: "row", style: Object.assign({}, { display: 'flex', flexDirection: 'row' }, // A row is a row anyway
            this.props.justifyContent ? { justifyContent: this.props.justifyContent } : {}, this.props.alignItems ? { alignItems: this.props.alignItems } : {}, this.props.alignSelf ? { alignSelf: this.props.alignSelf } : {}, this.props.height ? { height: this.props.height } : {}, this.props.minHeight ? { minHeight: this.props.minHeight } : {}, this.props.flex ? { flex: this.props.flex } : {}) }, this.props.children));
    };
    return Row;
}(React.Component));
exports.Row = Row;
